import ProductTileContainer from "./ProductTileContainer.js";
import { useDispatch } from "react-redux";
import { sendPlacementOnViewBeacon } from "../../state/modules/search/actions";
import { anchorProductToUrl } from "../../state/modules/search/productTile/actions.js";
import { analyticsProductClick } from "../../state/modules/analytics/actions";

const ConnectedProductTile = props => {
  const dispatch = useDispatch();

  return (
    <ProductTileContainer
      {...props}
      sendPlacementOnViewBeacon={() => dispatch(sendPlacementOnViewBeacon())}
      analyticsProductClick={args => dispatch(analyticsProductClick(args))}
      anchorProductToUrl={args => dispatch(anchorProductToUrl(args))}
    />
  );
};

export default ConnectedProductTile;
